import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * Header tipográfico pequeño que separa secciones del sidebar ("Navegación",
 * "Administración"). Al colapsar NO se desmonta ni cambia de altura: RESERVA su
 * espacio (max-height + margin constantes) y solo desvanece la OPACIDAD. Así los
 * iconos de los items NO se mueven verticalmente al colapsar/expandir — el layout
 * vertical es idéntico en ambos estados; solo el texto aparece/desaparece en fade.
 */
export function SectionLabel({
  children,
  colapsado,
}: {
  children: ReactNode;
  colapsado?: boolean;
}) {
  return (
    <p
      aria-hidden={colapsado || undefined}
      className={cn(
        "mb-1.5 max-h-5 overflow-hidden px-2 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground",
        "transition-opacity ease-[cubic-bezier(0.08,1,0.12,1)] duration-[var(--navbar-anim-ms,720ms)]",
        colapsado ? "opacity-0" : "opacity-100"
      )}
    >
      {children}
    </p>
  );
}
